const segments = 8,
    segmentAngle = 360 / segments;

const wheelState = new WeakMap();

/**
 * @param {HTMLElement} el
 *
 * @return {number}
 */
function getRotationAngle(el) {
    const style = window.getComputedStyle(el),
        transform = style.transform;

    if (transform === 'none') return 0;

    const values = transform.match(/matrix\((.+)\)/)[1].split(', '),
        a = parseFloat(values[0]),
        b = parseFloat(values[1]);

    return Math.atan2(b, a) * (180 / Math.PI);
}

/**
 * @param {HTMLElement} wheel
 * @param {number} segmentOffset
 */
function watchWheel(wheel, segmentOffset) {
    const wheelContent = wheel.querySelector(".wheel__content"),
        ticker = wheel.querySelector(".wheel__ticker");

    const angle = getRotationAngle(wheelContent) - segmentOffset,
        lastAngle = wheelState.get(wheel);

    if (lastAngle !== undefined) {
        const prevIndex = Math.floor(lastAngle / segmentAngle),
            currentIndex = Math.floor(angle / segmentAngle);

        if (currentIndex !== prevIndex) {
            flickTicker(ticker);
        }
    }

    wheelState.set(wheel, angle);
    requestAnimationFrame(() => watchWheel(wheel, segmentOffset));
}

function flickTicker(ticker) {
    ticker.classList.remove("ticker-flick");
    void ticker.offsetWidth;
    ticker.classList.add("ticker-flick");
}

/**
 * @param {HTMLElement} wheel
 */
function showWheelButton(wheel) {
    wheel.querySelector(".wheel__button").classList.add("show");
}

/**
 * @param {HTMLElement} wheel
 */
function hideWheelButton(wheel) {
    wheel.querySelector(".wheel__button").classList.remove("show");
}

function initiateSpin(wheel) {
    const wheelContent = wheel.querySelector(".wheel__content");

    hideWheelButton(wheel);
    wheelContent.classList.add('spin');
    waitForSpinToComplete(wheel, () => {
        wheelContent.classList.remove('spin');
        showWheelButton(wheel);
    });
}

function waitForSpinToComplete(wheel, callback) {
    /**
     * @param {AnimationEvent} ev
     */
    const onWheelRotateEndedListener = (ev) => {
        if (ev.animationName !== "wheel-rotate") return;
        callback();
        ev.currentTarget.removeEventListener("animationend", onWheelRotateEndedListener);
    }

    wheel.addEventListener("animationend", onWheelRotateEndedListener);
}

document.addEventListener("DOMContentLoaded", () => {
    const wheel = document.querySelector("#hero .wheel"),
        wheelContent = wheel.querySelector(".wheel__content");

    wheelContent.classList.add('first-spin');

    waitForSpinToComplete(wheel, () => {
        showWheelButton(wheel);

        wheelContent.classList.remove('first-spin');
    });
})

// Move the wheel to front (z-index) after the entry animation to allow interaction with the button
document.addEventListener("DOMContentLoaded", () => {
    const heroWheelContainer = document.querySelector(".hero__decor-1");

    heroWheelContainer.addEventListener("transitionend", (ev) => {
        heroWheelContainer.classList.add("bring-to-front");
    }, {once: true})
})

document.querySelector('.wheel__button').addEventListener('click', (ev) => {
    initiateSpin(ev.currentTarget.closest('.wheel'));
})

document.querySelectorAll('.wheel').forEach(wheel => {
    const segmentOffset = wheel.classList.contains('wheel-winning') ? 22.5 : 0;

    watchWheel(wheel, segmentOffset);
})
